<template>
  <div id="content">
    <broadcast-search
        v-model="entity.id_broadcasts"
        @broadcast-search-names="broadcastNames = arguments[0]"
        ref="broadcastsearchref"
    />
    <div class="inner">
      <p class="paging" v-if="isSubscriber">
        <router-link :to="{ name: 'subscriberDetail', params: {id: this.idSubscriber, tab: 'dashboard'} }" class="btn btn_back" v-translate>Seznam</router-link>
      </p>
      <p class="paging" v-else>
        <router-link :to="{ name: 'dashboardCarousels'}" class="btn btn_back" v-translate>Seznam</router-link>
      </p>
      <h1 v-translate>Nový carousel</h1>
    </div>
    <div class="responsiveTabs r-tabs" v-if="entity">
      <BasicInfo
          :entity="entity"
          :editable="true"
          :broadcast-names="broadcastNames"
          @broadcast-search-modal="$refs.broadcastsearchref.showModal(true, arguments[0])"
          @broadcast-search-names="broadcastNames = arguments[0]"
      />
      <section class="buttons">
        <p>
          <router-link  v-if="isSubscriber" :to="{ name: 'subscriberDetail', params: {id: this.idSubscriber, tab: 'dashboard'} }" class="btn btn_back btn_seznam" v-translate>Seznam
          </router-link>
          <router-link  v-else :to="{ name: 'dashboardCarousels'}" class="btn btn_back btn_seznam" v-translate>Seznam
          </router-link>
          <input type="submit" :value="'Uložit' | translate"
                 :class="['btn']"
                 @click.prevent.stop="createEntity(false, redirectParams)">
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions";
import dashboardCarousel from "./mixins/dashboardCarousel";
import BasicInfo from "./detail/BasicInfo";
import BroadcastSearch from "../../common/BroadcastSearch.vue";

export default {
  name: "DashboardCarouselNew",
  components: {BasicInfo, BroadcastSearch},
  mixins: [detailActions, dashboardCarousel],
  data() {
    return {
      broadcastNames: {},
    };
  },
  created(DashboardCarouselService) {
    this.entityService = DashboardCarouselService;
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/components/views/dashboardCarousels/DashboardCarouselNew.vue